import component from './PhHardDrives.vue_vue&type=script&lang.js';
export { default } from './PhHardDrives.vue_vue&type=script&lang.js';
import { render } from './PhHardDrives.vue_vue&type=template&id=6ba6dc45&lang.js';

component.render = render;
